import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';
const API_URL = `${BASE_URL}/api/esp32`;

// Update device output state
const updateOutputState = async (data, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.post(`${API_URL}/update-output-state`, data, config);
    return response;
};

const outputStateService = {
    updateOutputState
};

export default outputStateService;